<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { RiskType } from "@/model/baseTypes";
import { riskIcon, riskTitle } from "@/model/baseTypes";
import type { FieldChange } from "@/model/change";

defineProps<{ field: FieldChange<RiskType> }>();
</script>

<template>
  <div class="change horizontal">
    <span class="change-value">
      <SvgIcon :name="riskIcon(field.old || '')" width="20" height="20" />
      {{ $t(riskTitle(field.old || "")) }}
    </span>
    <SvgIcon
      name="arrow/right"
      width="20"
      height="20"
      role="img"
      :aria-label="$t('label.cardDiff.changedTo')"
    />
    <span class="change-value">
      <SvgIcon :name="riskIcon(field.new!)" width="20" height="20" />
      {{ $t(riskTitle(field.new!)) }}
    </span>
  </div>
</template>
